var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-range-picker',{staticStyle:{"width":"220px"},attrs:{"allowClear":false,"locale":_vm.locale,"value":[this.moment(_vm.startTime, _vm.dateFormat),this.moment(_vm.endTime, _vm.dateFormat)]},on:{"change":_vm.onChangeDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }